import { AppConfiguration } from "../app-configuration";
export class IstatConfiguration {
    // ISTAT
    public static ricercaIstat = AppConfiguration.SECURED + '/api/istat/ricercaIstat/';
    public static ricercaIstatByIdProfilo = AppConfiguration.SECURED + '/api/istat/ricercaIstatByIdProfilo/';
    public static salvaIstatByIdProfilo = AppConfiguration.SECURED + '/api/istat/salvaIstatByIdProfilo/';
    public static eliminaIstatByIdProfilo = AppConfiguration.SECURED + '/api/istat/eliminaIstatByIdProfilo/';
    public static ricercaIstatByIdCompetenza = AppConfiguration.SECURED + '/api/istat/ricercaIstatByIdCompetenza/';
    public static salvaIstatByIdCompetenza = AppConfiguration.SECURED + '/api/istat/salvaIstatByIdCompetenza/';
    public static eliminaIstatByIdCompetenza = AppConfiguration.SECURED + '/api/istat/eliminaIstatByIdCompetenza/';
    public static getCodiciIstatByIdProposta = AppConfiguration.SECURED + '/api/getCodiciIstatByIdProposta/';
    public static getCodiciIstatByIdCompetenza = AppConfiguration.SECURED + '/api/getCodiciIstatByIdCompetenza/';
    public static getElencoIstat = AppConfiguration.SECURED + '/api/istat/getElencoIstat/';
}